import * as React from 'react';
import { ConfigConsumer } from '.';
const renderEmpty = (componentName) => (<ConfigConsumer>
    {({ getPrefixCls }) => {
    const prefix = getPrefixCls('empty');
    switch (componentName) {
        case 'Table':
        case 'List':
            return '暂无数据1';
        case 'Select':
        case 'TreeSelect':
        case 'Casecader':
        case 'Transfer':
            return <div className={`${prefix}-small`}/>;
        default:
            return '暂无数据';
    }
}}
  </ConfigConsumer>);
export default renderEmpty;
